export const ActionTypes = {
  LOADING: "GET_PROS_LOADING",
  ERROR: "GET_PROS_ERROR",
  SUCCESS: "GET_PROS_SUCCESS",
};
